import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormArray,
  Validators,
  FormControl
} from '@angular/forms';
import { Location } from '@angular/common';

import { ModalComponent } from '../../modal/modal.component';
import { CommentPluginService } from './comment-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';

@Component({
    selector: 'comment-edit',
    templateUrl: './comment-edit.component.html',
    standalone: false
})
export class CommentEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  plugin: any;
  editForm: UntypedFormGroup;
  public currentItem: any;
  public types: any;
  public importanceLevels: any[];
  public icons: any[];
  public processing = false;
  private commentToRemove: number;

  @ViewChild('typesModal', { static: true }) typeModal: ModalComponent;
  @ViewChild('iconsModal', { static: true }) iconsModal: ModalComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;
  @ViewChild('commentDeleteConfirm', { static: true }) commentDeleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: CommentPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateComment(this.inspectionId, this.pointId, this.pluginId, model.remarks).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.types = _.orderBy(this.service.getTypes(), ['label']);
    this.importanceLevels = _.orderBy(this.service.getImportanceLevels(), ['value']);
    this.icons = _.orderBy(this.service.getIcons(), ['value']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  public openTypesSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.typeModal, this.types, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    this.currentItem = control.controls[i];
  }

  public openIconsSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.iconsModal, this.icons, selectedIndex || selectedIndex === 0 ? selectedIndex : -1, {
      showAsIcons: true
    });
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    this.currentItem = control.controls[i];
  }

  public selectTypesMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Type'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Type'].setValue(selectedIndex);
  }

  public selectIconsMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Icon'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Icon'].setValue(selectedIndex);
  }

  public onClose(e: any) {
    this.currentItem.controls['Type'].markAsTouched();
    this.currentItem.controls['Icon'].markAsTouched();
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['remarks'];
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    control.push(this.initRemark());
  }

  initForm() {
    this.editForm = this.fb.group({
      remarks: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    _.forEach(this.plugin.config.Remarks, (el) => {
      control.push(this.initRemark(el));
    });
  }

  initRemark(el?: any) {
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    return this.fb.group({
      Comment: new UntypedFormControl(el && el.Comment ? el.Comment.replace(regex, '\n') : '', Validators.required),
      Type: [el && !isNaN(parseInt(el.Type)) ? parseInt(el.Type) : '', [Validators.required, Validators.min(0)]],
      Icon: [el && el.Icon ? parseInt(el.Icon) : ''],
      Id: el && el.Id
    });
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    control.removeAt(this.commentToRemove);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openCommentDeleteConfirm(i: number) {
    this.commentDeleteConfirm.open();
    this.commentToRemove = i;
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
